import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20background%20with%20warm%20cream%20and%20sage%20green%20tones%2C%20organic%20flowing%20shapes%2C%20minimalist%20natural%20texture%2C%20calming%20wellness%20aesthetic%2C%20gentle%20light%20diffusion%2C%20serene%20atmosphere&width=1920&height=800&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-accent-900/70"></div>
      </div>
      <div className="relative w-full px-6 md:px-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-white leading-tight">
          准备好了吗？从今天开始，做更好的自己
        </h2>
        <p className="mt-4 text-sm md:text-base text-accent-200 max-w-lg mx-auto">
          关注我们的抗衰知识库，获取最新的科学抗衰老方案和实用建议，让我们一起越活越年轻。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/kang-shuai-hu-fu"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始探索 <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}